import React, { useEffect, Fragment } from "react";
import controllers from "../../controllers/events";
import LoaderData from "../../component/LoaderData/LoaderData";
import { useTranslation } from "react-i18next";
import moment from "moment";

const NewsList = () => {
  const { i18n } = useTranslation();
  const isEnglish = i18n.language === "en";

  const [data, setData] = React.useState(false);
  const [loading, setLoading] = React.useState(false);

  useEffect(() => {
    const getEventsList = () => {
      setLoading(true);
      const path = window.location.pathname;
      const limitValue = path === "/" || path === "/home" ? 3 : 100;
      return controllers
        .getEventsList({
          limit: limitValue,
          page: 0,
        })
        .then((response) => {
          setData(response);
          setTimeout(() => {
            setLoading(false);
          }, 400);
        })
        .catch((error) => {
          setLoading(false);
          window.location.href = "/500";
        });
    };
    getEventsList();
  }, []);

  if (loading) {
    return <LoaderData />;
  }

  return (
    <Fragment>
      <div className="row mt_dec--30">
        {(!data && !loading) ||
          (data.length === 0 && !loading && (
            <h4
              style={{
                textAlign: "center",
                margin: "50px auto",
                color: "#c4c4c4",
              }}
            >
              {isEnglish ? "No News found !" : "Aucune Evènements trouvée !"}
            </h4>
          ))}
        {data &&
          data.length > 0 &&
          data.map((value, index) => (
            <div
              className="col-lg-4 col-md-6 col-sm-12 col-12 mt--30"
              key={index}
            >
              <div className="im_box">
                <div id="news" className="thumbnail">
                  <a
                    href={
                      "/news/" +
                      value.title.fr.split(" ").join("-") +
                      "/?id=" +
                      value.id
                    }
                  >
                    <img
                      className="w-100"
                      src={`${process.env.REACT_APP_DOMAIN}/api/eventsimages/${value.event_id}/${value.image}`}
                      alt="News Images"
                    />
                  </a>
                </div>
                <div className="content">
                  <div className="inner">
                    <div className="content_heading">
                      <div className="category_list">
                        <a
                          href={
                            "/news/" +
                            value.title.fr.split(" ").join("-") +
                            "/?id=" +
                            value.id
                          }
                        >
                          {isEnglish
                            ? "Publication Date"
                            : "Date de publication "}{" "}
                          : {moment(value.date).format("DD MMM,YYYY")}
                          <br />
                          {value.duration &&
                            value.duration.startDate &&
                            value.duration.endDate && (
                              <div className="">
                                {isEnglish ? "Duration" : "Durée"} :{" "}
                                {moment(value.duration.startDate).format(
                                  "DD MMM,YYYY"
                                )}{" "}
                                {" - "}
                                {moment(value.duration.endDate).format(
                                  "DD MMM,YYYY"
                                )}
                              </div>
                            )}
                        </a>
                      </div>
                      <h4 className="title">
                        <a
                          href={
                            "/news/" +
                            value.title.fr.split(" ").join("-") +
                            "/?id=" +
                            value.id
                          }
                        >
                          {isEnglish
                            ? value.title.en
                                .split(" ")
                                .splice(0, 10)
                                .join(" ") + "..."
                            : value.title.fr
                                .split(" ")
                                .splice(0, 10)
                                .join(" ") + "..."}
                        </a>
                      </h4>
                    </div>
                    <div className="content_footer">
                      <a
                        href={
                          "/news/" +
                          value.title.fr.split(" ").join("-") +
                          "/?id=" +
                          value.id
                        }
                        className="rn-btn btn-opacity"
                      >
                        {isEnglish ? "Read More" : "Voir plus"}
                      </a>
                    </div>
                  </div>
                  <a
                    className="transparent_link"
                    href={
                      "/news/" +
                      value.title.fr.split(" ").join("-") +
                      "/?id=" +
                      value.id
                    }
                  ></a>
                </div>
              </div>
            </div>
          ))}
      </div>
    </Fragment>
  );
};
export default NewsList;
